import styles from './ControlGroupContainer.module.css'
import {clsx} from 'clsx'
import {isFeatureEnabled} from '@github-ui/feature-flags'

type ControlGroupContainerProps = {
  children: React.ReactNode
  border?: boolean
  fullWidth?: boolean
  /** Controls the internal padding/gap of items. 'default' uses compact spacing, 'spacious' uses larger spacing. */
  gap?: 'default' | 'spacious'
  ['data-testid']?: string
  className?: string
}

const ControlGroupContainer = ({
  children,
  fullWidth = false,
  border = true,
  gap = 'default',
  'data-testid': testId,
  className,
}: ControlGroupContainerProps) => {
  const controlGroupUnificationEnabled = isFeatureEnabled('control-group-unification')
  if (controlGroupUnificationEnabled) {
    return (
      <div
        data-testid={testId}
        className={clsx(
          styles.ControlGroupContainer,
          fullWidth && styles.fullWidth,
          border && styles.border,
          gap === 'spacious' && styles.spacious,
          className,
        )}
      >
        {children}
      </div>
    )
  } else {
    return (
      <div
        data-testid={testId}
        className={clsx(
          styles.ControlGroupContainer,
          fullWidth && styles.fullWidth,
          border && styles.border,
          className,
        )}
      >
        {children}
      </div>
    )
  }
}

export default ControlGroupContainer
